import shamautMachriaComponent from './shamaut-machria.component';

const shamautMachria = angular.module('shamautMachria', [
])
  .component('shamautMachria', shamautMachriaComponent)
  .name;

export default shamautMachria;
